import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";

export default class AbstractDocument {
    protected _type: DocumentTypes = DocumentTypes.UNKNOWN;

    get type(): DocumentTypes {
        return this._type;
    }
}